import { render, staticRenderFns } from "./ProductAddList.vue?vue&type=template&id=ba3e1cea&"
import script from "./ProductAddList.vue?vue&type=script&lang=ts&"
export * from "./ProductAddList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports